<template>
  <div class="field has-addons" >
    <div
      :class="`control is-expanded`+
        `${['manyrelated', ].includes(field.type) ? ' ' : ''}`+
        `${field.icon ? ' has-icons-left' : ''}`"
      @click="$emit('clicked', $event)"
      :is-loading="loading"
    >

      <!-- если поле - селект -->
      <div :class="`select is-fullwidth ${iclass}`" v-if="['select', 'choice'].includes(field.type)">
        <select :id="$vnode.key" :name="field.name" :multiple="field.multiple" @change="$emit('update:finput', $event.target.value)" :value="finput" :required="field.required" :disabled="disabled">
          <!-- <option disabled :value="finput || field.choices[0].value"></option> -->
          <option :value="option.value" v-for="(option, index) in field.choices" :key="index"  :disabled="option.disabled">{{option.display_name}}</option>
        </select>
      </div>

      <!-- если поле текст ареа -->
      <textarea
        v-else-if="field.type === 'textarea'"
        :type="field.type"
        @input="$emit('update:finput', $event.target.value)"
        :class="`input ${iclass} ${error ? 'is-danger': ''}`"
        :placeholder="field.placeholder"
        :value="finput"
        :required="field.required"
        :disabled="disabled"
      ></textarea>

      <!-- если поле булево -->
      <template v-else-if="['boolean'].includes(field.type)">
        <input type="checkbox" :class="`switch is-rounded ${iclass}`" @input="$emit('update:finput', $event.target.checked)" :checked="finput" :id="$vnode.key" :required="field.required" :disabled="disabled">
        <label :for="$vnode.key" :class="`${iclass}`"></label>
      </template>

      <!-- если поле primarykey -->
      <div
        v-else-if="['primarykey', ].includes(field.type)"
        type="text"
        :class="`input is-fullwidth ${iclass}`"
        @click.prevent="() => {
          if (!disabled) {
            many = false
            modal = true
            getOptions()
          }
        }"
        :id="$vnode.key"
      >
        {{comletedInput(finput)}}
      </div>

      <!-- если поле manyrelated -->
      <div class="input" v-else-if="['manyrelated', ].includes(field.type)" style="height:auto;">
        <div class="control">
          <div class="tags">
            <div class="tag" v-for="(item, index) in finput" :key="index">
              {{ item.__str__ || item.title || item.name || item.pk || item.id || item}}
              <button type="button" class="delete is-small" @click.prevent="$emit('update:finput', $_.reject(finput, {id: item.id}) )" ></button>
            </div>
            <a class="tag is-primary" @click.prevent="many = true, modal = true, getOptions()">
              <span class="icon" ><i class="fas fa-plus"></i></span>
            </a>
            <a class="tag is-danger" @click.prevent="$emit('update:finput', null)">
              <span class="icon" ><i class="fas fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>

      <!-- если поле - дата -->
      <b-datetimepicker
        v-else-if="['datetime', ].includes(field.type)"
        :type="`${field.type}-local`"
        rounded
        @input="val => $emit('update:finput', $moment(val).format())"
        :value="finput && new Date($moment(finput))"
        :datetime-formatter="date => $moment(date).format('LLL')"
        :datetime-parser="date => new Date($moment(date))"
        :placeholder="field.placeholder"
        :datepicker='{
          "first-day-of-week": 1,
          "month-names": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
          "day-names": ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        }'
        icon="calendar-alt"
        icon-pack="fas"
        :class="`${error ? 'is-danger': ''}`"
        :size="iclass"
        :editable="false"
        :id="$vnode.key"
      >
        <template slot="left">
          <button class="button is-primary has-icon-left"
            type="button"
            @click="$emit('update:finput', $moment().format() )">
            <span class="icon"><i class="fas fa-calendar-day"></i></span>
            <span>Сейчас</span>
          </button>
        </template>
      </b-datetimepicker>

      <!-- если поле - дата -->
      <b-datepicker
        v-else-if="['date'].includes(field.type)"
        @input="val => $emit('update:finput', $moment(val).format())"
        :value="finput && new Date($moment(finput))"
        :date-formatter="date => $moment(date).format('LL')"
        :date-parser="date => new Date($moment(date))"
        :placeholder="field.placeholder"
        :first-day-of-week=1
        :month-names='["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]'
        :day-names='["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]'
        icon="calendar-alt"
        icon-pack="fas"
        :class="`${error ? 'is-danger': ''}`"
        :size="iclass"
        :editable="false"
        :id="$vnode.key"
      >
        <template slot="left">
          <button class="button is-primary has-icon-left"
            type="button"
            @click="$emit('update:finput', $moment().format() )">
            <span class="icon"><i class="fas fa-calendar-day"></i></span>
            <span>Сейчас</span>
          </button>
        </template>
      </b-datepicker>

      <!-- если поле - файл -->
      <div class="file has-name is-fullwidth" v-else-if="field.type === 'file upload'">
        <label class="file-label">
          <input class="file-input" type="file" :id="$vnode.key" @change="$emit('update:finput', $event.target.files[0])">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">
              Файл…
            </span>
          </span>
          <span class="file-name">
            {{finput && finput.name}}
          </span>
        </label>
      </div>

      <!-- в иных случаях поле обычное или автокомплит -->
      <input
        v-else
        :type="mapType(field.type)"
        @input="autocomplete && debouncedGetOptions(), $emit('update:finput', $_.trim($event.target.value))"
        :class="`input ${iclass} ${error ? 'is-danger': ''}`"
        :placeholder="field.placeholder"
        :value="finput"
        :required="field.required"
        :disabled="disabled"
        :id="$vnode.key"
      >

      <!-- иконка -->
      <span v-if="field.icon" class="icon is-small is-left">
        <i :class="`fas fa-${field.icon}`"></i>
      </span>

      <!-- подсказка или ошибки -->
      <p v-if="!disabled" :class="`help ${error ? 'is-danger': ''} ${pclass}`">{{(error && error.non_field_errors || $_.isArray(error)) && $_.join(error.non_field_errors || error) || info}}</p>

      <!-- модальное окно выбора опции -->
      <div class="modal is-active" v-if="modal">
        <div class="modal-background"  @click="modal = false"></div>
        <div class="modal-card">
          <header class="modal-card-head" style="padding-top:.35rem;padding-bottom:.35rem;">
            <p class="">
              <input type="checkbox" class="switch is-rounded" id="mobile-view" v-model="mobile">
              <label for="mobile-view"></label>
            </p>
            <label for="mobile-view" class="modal-card-title" style="flex-shrink:initial;">
              <p class="title is-4">{{field.label}} </p>
              <p class="subtitle is-6">{{mobile ? 'мобильный' : 'расширенный'}} вид</p>
            </label>
            <button class="delete" aria-label="close"  @click="modal = false"></button>
          </header>
          <div class="modal-card-body">
            <div class="table-container" >
              <Table
                :theader="filteredData[0] && Object.keys(filteredData[0])"
                :tdata="filteredData"
                @selected="selectVal"
                :selected="finput && $_.isArray(finput) ? finput : []"
                class="is-hoverable is-striped transparent"
                style="min-width:100%;"
              ></Table>
            </div>
            <!-- пагинация - покажем, если число записей больше limit -->
            <nav class="pagination" role="navigation" aria-label="pagination" v-if="options.count > options.limit">
              <a  class="pagination-previous" @click.prevent="options.page--, getOptions()" v-if="options.page > 1">Назад</a>
              <a  class="pagination-next" @click.prevent="options.page++, getOptions()" v-if="options.count > options.page * options.limit">Дальше</a>
              <ul class="pagination-list">
                <template v-if="options.page > 2">
                  <li>
                    <a @click.prevent="options.page = 1, getOptions()" class="pagination-link" aria-label="Goto page 1">1</a>
                  </li>
                  <li>
                    <span class="pagination-ellipsis">&hellip;</span>
                  </li>
                </template>
                <li>
                  <a @click.prevent="options.page--, getOptions()" class="pagination-link" :aria-label="`Goto page ${options.page - 1}`" v-if="options.page > 1">{{options.page - 1}}</a>
                </li>
                <li>
                  <a disabled class="button pagination-link is-current" :aria-label="`Page ${options.page}`" :aria-current="options.page">{{options.page}}</a>
                </li>
                <li>
                  <a @click.prevent="options.page++, getOptions()" class="pagination-link" :aria-label="`Goto page ${options.page + 1}`" v-if="options.page * options.limit < options.count">{{options.page + 1}}</a>
                </li>
                <template v-if="(options.page + 1) * options.limit <= options.count">
                  <li>
                    <span class="pagination-ellipsis">&hellip;</span>
                  </li>
                  <li>
                    <a @click.prevent="options.page = Math.ceil(options.count / options.limit), getOptions()" class="pagination-link" :aria-label="`Goto page ${Math.ceil(options.count / options.limit)}`">{{ Math.ceil(options.count / options.limit) }}</a>
                  </li>
                </template>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- боковые кнопки поля инпут -->

    <!-- кнопка очистить поле -->
    <div class="control" v-if="['file upload', 'datetime', 'primarykey', ].includes(field.type) && !disabled">
      <button :class="`button has-text-grey-lighter ${iclass}`" title="очистить" type="button" @click.prevent="$emit('update:finput', null)" :disabled="disabled">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Table: () => import('@/components/Table.vue')
  },
  props: {
    field: Object,
    name: String,
    iclass: String,
    pclass: String,
    finput: [Object, String, Array, Number, Boolean, File],
    error: [String, Array, Boolean, Object],
    info: [String, Array, Boolean],
    autocomplete: {
      type: Boolean,
      default: false
    },
    disabled: Boolean
  },
  data () {
    return {
      focused: false,
      options: {
        options_list: [],
        count: 0,
        limit: 10,
        page: 1
      },
      loading: false,
      modal: false,
      many: false,
      mobile: !!this.$isMobile.any(),
      profession: ''
    }
  },
  computed: {
    filteredData () {
      const list = this.options.options_list
      // фильтруем вывод таблицы данных
      const fields = this.mobile ? ['pk', 'id', 'name', 'title', '__str__', 'owner', 'sign'] : list[0] && Object.keys(list[0])
      return list.map(val => this.$_.pick(val, fields))
    }
  },
  created () {
    // устанавливает задержку события инпута (дебонс)
    this.debouncedGetOptions = this.$_.debounce(this.getOptions, 400)
  },
  methods: {
    mapType (type) {
      // конвертирует типп данных поля в стандартные типы инпута
      // let mapType = {
      //   date: [],
      // }
      switch (type) {
        case 'integer':
          type = 'number'
          break
        case 'file upload':
          type = 'file'
          break
      }
      return type
    },
    selectVal (value) {
      // действие при выборе объекта из модального окна. отправляет выбранный объек и закрывает окно
      if (this.many) {
        this.$emit('update:finput', value)
        return
      }
      this.$emit('update:finput', value[0])
      this.modal = false
    },
    comletedInput (finput) {
      // преобразует объект в обычное поле для нормального отображения
      if (finput) return finput.__str__ || finput
      return 'не выбрано'
    },
    getOptions () {
      // запрашивает поля для автокомплита
      this.loading = true
      this.profession = this.name === 'driver' ? this.name : ''
      const field = this.field
      const url = `/${field.app}/${field.model}/`

      const params = {
        limit: this.options.limit,
        offset: (this.options.page - 1) * this.options.limit,
        unused: true,
        organization: this.$store.state.user.appointment.profession.name === 'analytic' ? '' : this.$store.state.user.appointment.organization.name,
        profession: this.profession
      }
      this.$axios.get(url, { params, headers: this.$store.state.user.axiosHeaders })
        .then(res => {
          this.options.options_list = res.data.results
          this.options.count = res.data.count
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss">
  .datetimepicker-dummy-input {
    max-width: 100%!important;
  }
</style>
